/**
 * Inquiries API (공개 사이트 문의하기)
 * POST /api/inquiries — 인증 없이 호출
 */

import apiClient from './client';

/** 문의 유형 */
export type InquiryType = '일반 문의' | '소개자료' | '도입 상담';

/** 구축 환경 (선택 입력) */
export type InquiryEnvironment = '클라우드' | '사내 설치·온프레미스' | '미정';

export interface CreateInquiryRequest {
  companyName: string;
  employeeCount: string;
  name: string;
  phone: string;
  email: string;
  visitRoute?: string;
  inquiryType: InquiryType;
  environment?: InquiryEnvironment;
  message: string;
  agreePrivacy: boolean;
  agreeMarketing: boolean;
}

export const inquiryApi = {
  async submit(data: CreateInquiryRequest): Promise<void> {
    await apiClient.post('/api/inquiries', data);
  },
};
